import React, { useState } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { get } from 'lodash';
import { RootState } from 'modules';
import { getMenuTitle } from 'components/base/HeaderLeft';
import { cookies, CCSRFToken } from 'libs/api/apiClient';
import { userLogout } from 'libs/api/user';
import { CUserType, CUserTypeColor } from 'constants/user.const';
import { EUserType } from 'enums/base.enum';
import { ERoute } from 'enums/route.enum';
import { Tag, Avatar, Menu, Col, Row, Typography, Button, Dropdown } from 'antd';

const { Text } = Typography;
type TRightMenuProps = {
  onClick?: () => void;
};
export const HeaderRight = ({ onClick }: TRightMenuProps) => {
  const currentUser = useSelector((state: RootState) => state.user.current_user, shallowEqual);
  const [visible, setVisible] = useState(false);
  const rightMenu = (
    <Menu onClick={onClickMenu}>
      <Menu.Item key='user-setting'>
        <Link to={ERoute.UserEdit}>{getMenuTitle(ERoute.UserEdit)[1]}</Link>
      </Menu.Item>
      {currentUser?.user_type === EUserType.Mentee && (
        <Menu.Item key='user-credit'>
          <Link to={ERoute.UserCredit}>{getMenuTitle(ERoute.UserCredit)[1]}</Link>
        </Menu.Item>
      )}
      {/* 멘토 전환하기 추가 */}
      {currentUser?.user_type === EUserType.Mentee && (
        <Menu.Item key='user-switch-to-mentor'>
          <Link to={ERoute.CSLabSwitchToMentor}>{getMenuTitle(ERoute.CSLabSwitchToMentor)[1]}</Link>
        </Menu.Item>
      )}

      {currentUser?.user_type === EUserType.Mentor && currentUser?.is_verified === true && (
        <Menu.Item key='user-credit-exchange'>
          <Link to={ERoute.UserCreditExchange}>{getMenuTitle(ERoute.UserCreditExchange)[1]}</Link>
        </Menu.Item>
      )}
      <Menu.Item key='logout'>로그아웃</Menu.Item>
    </Menu>
  );

  async function onClickLogout() {
    try {
      await userLogout();
      cookies.remove('sessionid');
      cookies.remove(CCSRFToken);
      window.location.href = ERoute.UserLogin;
      window.localStorage.removeItem(CCSRFToken);
    } catch (e) {
      throw e;
    }
  }

  function onClickMenu(e: any) {
    switch (e.key) {
      case 'user-setting':
      case 'user-credit':
      case 'user-credit-exchange':
        break;
      case 'logout':
        onClickLogout();
        break;
      case 'admin-page':
        break;
    }
    onClick && onClick();
    setVisible(false);
  }

  function onClickButton() {
    onClick && onClick();
  }

  return (
    <Row align='middle' justify='end'>
      {currentUser ? (
        <div style={{ marginRight: '16px' }}>
          <Dropdown
            overlay={rightMenu}
            placement='bottomLeft'
            onVisibleChange={() => {
              setVisible(!visible);
            }}
            visible={visible}
          >
            <div
              style={{
                display: 'inline-block',
                cursor: 'pointer',
              }}
            >
              <Row align='middle'>
                <Col>
                  <Avatar
                    shape='circle'
                    style={{ marginRight: '2px' }}
                    src={get(currentUser, 'profile_image.absolute_url')}
                  />
                </Col>
                <Col>
                  <Tag
                    style={{
                      fontSize: '11px',
                      marginRight: '2px',
                      padding: '0px 4px',
                      borderRadius: '4px',
                    }}
                    // color={CUserTypeColor[get(currentUser, "user_type")]}
                    color={CUserTypeColor[get(currentUser, 'user_type')]}
                  >
                    {CUserType[get(currentUser, 'user_type')]}
                  </Tag>
                </Col>
                <Col>
                  <div style={{ height: '100%' }}>
                    <Text style={{ fontSize: '12px' }} strong={true}>
                      {currentUser.fullname}
                    </Text>
                  </div>
                </Col>
              </Row>
            </div>
          </Dropdown>
        </div>
      ) : (
        <>
          <Link to={ERoute.UserLogin}>
            <Button size='small' style={{ margin: '0px 4px' }} onClick={onClickButton}>
              <span style={{ display: 'unset' }}>로그인</span>
            </Button>
          </Link>
          <Link to={ERoute.UserSignup}>
            <Button size='small' type='primary' style={{ margin: '0px 4px' }} onClick={onClickButton}>
              <span style={{ display: 'unset' }}>회원가입</span>
            </Button>
          </Link>
        </>
      )}
    </Row>
  );
};
